export const BASE_ASSET_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1742407189/onboarding_assets/sider_images'
